import React from 'react'
import './Pricing.css';
import NavBar from './NavBar';
import PricingSection from './PricingSection';

const Pricing = () => {
  return (
    <div className="Page">
      <div className='content'>
        <NavBar/>
        <div className='PricingContent'>
        <div className='title'>Choose the plan that's right for <span className='green'>your business.</span></div>
        <div className='subtitle'>Subscribe today and cancel anytime.</div>
            <PricingSection/>
        </div>
        </div>
    </div>
  )
}

export default Pricing